import * as React from 'react';
import { Grid } from '@mui/material';
import DownloadPaper from './DownloadPaper';

import '../ContentPagesStyles.css';

export interface IDownloadPageProps {

}

const DownloadPage = (props: IDownloadPageProps) => {

    return(
        <Grid className="content-page-content" container direction="column" justifyContent="center">
            <Grid className="content-page-header" item>
                <span className="header-3dtext">Downloads</span>
            </Grid>
            <Grid className="content-page-divider-div" item>
                <div className="content-page-divider"/>
            </Grid>
            <Grid item style={{height: "200px", width: "100%"}}>
                <DownloadPaper />
            </Grid>
        </Grid>
    );
}

export default DownloadPage;